const InnerAbout = () => {
    return (
        <div className="text-2xl">Inner About</div>
    )
}

export default InnerAbout;